import React, { useState } from "react";
import { Spinner, Alert, Form, Button, Card } from "react-bootstrap";
import { GoogleLogin, googleLogout } from "@react-oauth/google";
import { useHistory, useLocation } from "react-router-dom";
import axios from "axios";
import Cookies from "universal-cookie";
import config from "../config";
import ReactGA from "react-ga";

const Login = () => {
  const cookies = new Cookies();
  const history = useHistory();
  const location = useLocation();
  const [credential, setCredential] = useState({ username: "", password: "" });
  const [errorMsg, setErrorMsg] = useState("");
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  function login(postData) {
    // console.log('Login.login postData=', postData);

    setIsLoggingIn(true);
    setErrorMsg("");

    axios
      .post("/api/login", postData, {
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "same-origin",
      })
      .then((res) => {
        // logged in successfully
        // console.log('/login res=', res);
        // console.log('/login res.data=', res.data);

        // store access token as cookies
        cookies.set(
          config.accessTokenCookieKey,
          res.data[config.accessTokenCookieKey],
          {
            // expires: res.data.exp,
            maxAge: res.data.maxAge,
            path: "/",
          }
        );
        cookies.set("username", res.data.username, {
          // expires: res.data.exp,
          maxAge: res.data.maxAge,
          path: "/",
        });

        // Google Analytics
        if (res.data.username) {
          // console.log('res.data.username=', res.data.username);
          ReactGA.set({
            userId: res.data.username,
          });
        }
        ReactGA.event({
          category: "Login",
          action: "Click",
          label: postData.type,
          value: 1,
        });

        // route user to the page requested
        let { from } = location.state || { from: { pathname: "/" } };
        setTimeout(() => {
          history.replace(from);
        }, 0);
      })
      .catch((err) => {
        console.log("err=", err);
        if (err.response) {
          // console.log(err.response.data);
          // console.log(err.response.status);
          // console.log(err.response.headers);
          if (err.response.status === 401) {
            switch (postData.type) {
              case "Basic":
                setErrorMsg("Invalid username and/or password.");
                break;
              case "Google":
                setErrorMsg(
                  "Only @privetechnologies.com email addresses are supported."
                );
                googleLogout();
                break;
              default:
                setErrorMsg("Incorrect credential.");
            }
            /* Fallback to disable Prive login
            const { errors } = err.response.data;
            if (Array.isArray(errors) && errors.length > 0) {
              setErrorMsg(errors.map((error) => error.message).join('\n').trim());
            } else {
              setErrorMsg('Invalid credentials');
            }
            */
          } else {
            setErrorMsg("Server error, please try again later.");
          }
        } else if (err.request) {
          // console.error('err.request=', err.request);
          setErrorMsg("No response from server, please try again later.");
        } else {
          // Something happened in setting up the request that triggered an Error
          // console.error('err.message', err.message);
          setErrorMsg("Server error, please try again later.");
        }
        // console.log('err.config=', err.config);
        ReactGA.event({
          category: "Login",
          action: "Click",
          label: postData.type,
          value: 0,
        });
      })
      .then(() => {
        setIsLoggingIn(false);
      });
  }

  function onSubmit(evt) {
    evt.preventDefault();
    const postData = {
      ...credential,
      // type: 'Prive',  //Fallback to disable Prive login
      type: "Basic",
    };
    login(postData);
  }

  function onGoogleLoginSuccess(googleRes) {
    // console.log('Login.login onGoogleLoginSuccess googleRes=', googleRes);
    const postData = {
      type: "Google",
      token: googleRes?.credential,
    };
    login(postData);
  }

  function onGoogleLoginFailure() {
    // console.log('Login.login onGoogleLoginFailure googleRes=', googleRes);
    setErrorMsg("Login failed");
  }

  function onUsernameChange(evt) {
    setCredential({ ...credential, username: evt.target.value });
  }

  function onPasswordChange(evt) {
    setCredential({ ...credential, password: evt.target.value });
  }

  return (
    <div className="centered-page">
      <Card className="login-form">
        <Card.Header>Login</Card.Header>
        <Card.Body>
          <Form onSubmit={onSubmit}>
            <Form.Group controlId="formUsername">
              <Form.Label>Username</Form.Label>
              <Form.Control
                type="text"
                placeholder="Username"
                onChange={onUsernameChange}
                value={credential.username}
              />
            </Form.Group>
            <Form.Group controlId="formPassword">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Password"
                onChange={onPasswordChange}
                value={credential.password}
              />
            </Form.Group>
            {/* <Form.Group controlId="formKeepLoggedIn">
              <Form.Check type="checkbox" label="Keep me logged in" />
            </Form.Group> */}
            <Button
              variant="primary"
              type="submit"
              disabled={
                isLoggingIn || !credential.username || !credential.password
              }
              block
            >
              <span hidden={isLoggingIn}>Login</span>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                // aria-hidden="true"
                hidden={!isLoggingIn}
              />
            </Button>
            <hr />
            <GoogleLogin
              onSuccess={onGoogleLoginSuccess}
              onError={onGoogleLoginFailure}
              width="80%"
            />
            <small>Only @privetechnologies.com email addresses are supported.</small>
          </Form>
        </Card.Body>
      </Card>
      <Alert
        variant="danger"
        show={errorMsg !== undefined && errorMsg.length > 0}
      >
        {errorMsg}
      </Alert>
    </div>
  );
};

export default Login;
